<template>
	<div class="flex wrap xs-12 xs-center">
		<!-- Credentials -->
		<!-- <div class="flex xs-12 xs-right mb2">
			<j-button :to="`${$route.path}/update-password`" type="tertiary">
				<crm-icon name="edit" size="small" />{{$t("change_password")}}
			</j-button>
            </div>-->
		<j-card class="mb4 bg5">
			<j-list :list="clientCredentials">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex xs-6 xs-left xs-middle fw7 c6">{{ item.left }}</div>
					<div class="flex xs-6 xs-right xs-middle">
						<j-avatar :src="item.img" v-if="item.img" />
						<div v-else>{{ item.right }}</div>
					</div>
				</div>
			</j-list>
		</j-card>

		<div class="flex wrap xs-12 xs-right">
			<!-- Change password -->
			<j-button
				@click="updatePassword"
				type="primary"
				class="mr2"
				action="changePassword"
				>{{ $t("change_password") }}</j-button
			>
			<!-- Log Out -->
			<j-button @click="onLogOut" type="error" action="logout">{{
				$t("log_out")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JHeadline from "@/components/JHeadline/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JList from "@/components/JList/"
import JAvatar from "@/components/JAvatar/"
import { mapState } from "vuex"
import dayjs from "dayjs"

export default {
	components: {
		CrmIcon,
		JButton,
		JHeadline,
		JCard,
		JDataTable,
		JList,
		JAvatar
	},
	props: {
		id: {
			type: String
		},
		section: {
			type: String,
			default: "overview"
		}
	},

	data() {
		return {}
	},

	computed: {
		clientCredentials() {
			return [
				{ left: this.$t("name"), right: this.$store.state.username },
				{ left: this.$t("email"), right: this.$store.state.email },
				{ left: this.$t("password"), right: "********" }
				// {
				// 	left: "Created",
				// 	right:
				// 		this.detail && this.detail.data.createdAt
				// 			? dayjs(this.detail.data.createdAt).format(this.settings.dateTimeFormat)
				// 			: null,
				// },
			]
		}
	},

	methods: {
		onLogOut() {
			this.$store.dispatch("auth/logOut", this.$store.state.tenantId)
		},
		updatePassword() {
			this.$router.push({ name: "AuthUpdatePassword" })
		}
	}
}
</script>
